import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=5130e92e&"
import script from "./DeleteUser.vue?vue&type=script&lang=ts&"
export * from "./DeleteUser.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports